var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCar = function SvgIcCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.6 4a1 1 0 0 0-.933-.667H4.333c-.466 0-.8.267-.933.667L2 8v5.333c0 .334.333.667.667.667h.666c.4 0 .667-.333.667-.667v-.666h8v.666c0 .334.333.667.667.667h.666c.334 0 .667-.333.667-.667V8zm-8.067.667H11.4l.733 2H3.867zm8.134 6.666H3.333V8h9.334zM5 8.667c.533 0 1 .466 1 1 0 .533-.467 1-1 1s-1-.467-1-1c0-.534.467-1 1-1m6 0c.533 0 1 .466 1 1 0 .533-.467 1-1 1s-1-.467-1-1c0-.534.467-1 1-1"
  })));
};
export default SvgIcCar;